/**
 * @generated SignedSource<<96b8398a99bec5162998e761e72f2025>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type deleteLearningInput = {
  clientMutationId?: string | null;
  id: string;
};
export type DeleteLearningMutation$variables = {
  connections: ReadonlyArray<string>;
  input: deleteLearningInput;
};
export type DeleteLearningMutation$data = {
  readonly deleteLearning: {
    readonly learning: {
      readonly id: string;
    } | null;
  } | null;
};
export type DeleteLearningMutation = {
  response: DeleteLearningMutation$data;
  variables: DeleteLearningMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DeleteLearningMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "deleteLearningPayload",
        "kind": "LinkedField",
        "name": "deleteLearning",
        "plural": false,
        "selections": [
          {
            "concreteType": "Learning",
            "kind": "LinkedField",
            "name": "learning",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteLearningMutation",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "deleteLearningPayload",
        "kind": "LinkedField",
        "name": "deleteLearning",
        "plural": false,
        "selections": [
          {
            "concreteType": "Learning",
            "kind": "LinkedField",
            "name": "learning",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "8cf31a4da9516bf9ad58ad5206f85739",
    "id": null,
    "metadata": {},
    "name": "DeleteLearningMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteLearningMutation(\n  $input: deleteLearningInput!\n) {\n  deleteLearning(input: $input) {\n    learning {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3c7a9ea61c2c326b064008cd016126db";

export default node;
